<div [class]="mainClasses">
  <div>
    <ul [class]="ulClasses + ' m-0 p-0'">
      <li *ngFor="let step of steps; let index = index" [class.active]="index === active" [class]="liClasses">
        <a
          class="waves-effect {{ step.notClickable ? 'not-clickable' : '' }}  {{ aClasses }} px-2"
          *ngIf="!step.notClickable"
          [attr.data-id-cypress]="step.idCypress"
          [class.invalid]="step.invalid"
          [routerLink]="step.url"
          (click)="active = index; activeChange.emit(index)"
          routerLinkActive="active"
        >
          <jhi-bary-icon *ngIf="step.icon" [icon]="step.icon" [faDirective]="FAS" class="mr-1"></jhi-bary-icon>
          {{ step.title | translate }}
        </a>
        <a class="waves-effect not-clickable px-2" *ngIf="step.notClickable" [class]="aClasses" [class.invalid]="step.invalid" routerLinkActive="active">
          <jhi-bary-icon *ngIf="step.icon" [icon]="step.icon" [faDirective]="FAS" class="mr-1"></jhi-bary-icon>
          {{ step.title | translate }}
        </a>
      </li>
    </ul>
  </div>
</div>
<!-- Tab panels -->
<div [class]="class">
  <router-outlet (activate)="handleActivate($event)"></router-outlet>
</div>
